import { registerBuiltInRuleSets } from './rules';
import { registerBuiltInGameModes } from './modes/registry.builtins';

/**
 * Fills the ruleset and mode registries. Idempotent.
 *
 * Called explicitly - once, at startup - by the server (`server/src/index.ts`)
 * and by the client (`client/src/main.ts`). Registration used to happen as an
 * import side effect, which broke the moment a file imported a ruleset's id
 * without importing the barrel that registered it. Ordering that depends on
 * which module someone happened to import first is not ordering.
 */
let done = false;

export function bootstrapShared(): void {
  if (done) return;
  registerBuiltInRuleSets();
  registerBuiltInGameModes();
  done = true;
}

/** Test-only: lets a suite re-run bootstrap against a cleared registry. */
export function resetBootstrap(): void {
  done = false;
}
